// eslint-disable-next-line no-restricted-modules
const $ = require('@trello/jquery');
const {
  AutoMentionerView,
} = require('app/scripts/views/internal/autocomplete/AutoMentionerView');
const {
  EmojiCompleterView,
} = require('app/scripts/views/internal/autocomplete/EmojiCompleterView');
const { Dates } = require('app/scripts/lib/dates');
const DragSort = require('app/scripts/views/lib/drag-sort');
const {
  hasSelectionIn,
} = require('app/scripts/lib/util/selection/has-selection-in');
const Layout = require('app/scripts/views/lib/layout');
const { Util } = require('app/scripts/lib/util');
const {
  stopPropagationAndPreventDefault,
} = require('app/src/stopPropagationAndPreventDefault');
const { PopOver } = require('app/scripts/views/lib/pop-over');
const { asNumber } = require('@trello/i18n/formatters');
import { TrelloStorage } from '@trello/storage';
const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'checklist_item',
);
const { l } = require('app/scripts/lib/localize');
const { isSubmitEvent, getKey, Key } = require('@trello/keybindings');
import { markdownTracker } from 'app/scripts/lib/markdown/markdownTracker';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

const {
  applyMarkdownShortcuts,
} = require('app/scripts/views/lib/markdown-transform');

const editTemplate = t.renderable(() => {
  t.div('.edit-controls.u-clearfix', () => {
    t.input(
      '.nch-button.nch-button--primary.confirm.mod-submit-edit.js-save-edit',
      {
        type: 'submit',
        value: t.l('save'),
      },
    );
    t.a('.icon-lg.icon-close.dark-hover.cancel.js-cancel-edit', { href: '#' });

    t.div('.edit-controls-spacer');

    t.a('.option.check-item-options-menu.dark-hover.js-assign.hide', {
      href: '#',
    });

    t.a(
      '.option.check-item-options-menu.dark-hover.js-due.checklist-add-controls-due.hide',
      { href: '#' },
    );

    t.a(
      '.option.check-item-options-menu.dark-hover.js-open-emoji-selector',
      { href: '#' },
      () => {
        t.span('.icon-sm.icon-emoji');
      },
    );

    t.a(
      '.option.check-item-options-menu.dark-hover.js-open-mention-selector',
      { href: '#' },
      () => {
        t.span('.icon-sm.icon-mention');
      },
    );

    //#currently the options menu is only used for CheckItems. If another use is added, add check for Checkitem
    t.div('.check-item-new-menu.ignore-editable-view.js-overflow-button-react');
  });
});

const editAssignTemplate = t.renderable((fullName: string | undefined) => {
  t.icon('add-member');
  if (fullName) {
    t.text(fullName);
  } else {
    t.format('assign');
  }
});

const editDueTemplate = t.renderable((dueText: string | undefined) => {
  t.icon('clock');
  if (dueText) {
    t.text(dueText);
  } else {
    t.format('due-date');
  }
});

export const _checkItemDraftKey = function () {
  return `draft_${this.model.id}_name`;
};
export const _saveCheckItemDraft = function (attr: string, value: string) {
  TrelloStorage.set(this._checkItemDraftKey(attr), value);
};
export const _recallCheckItemDraft = function () {
  return TrelloStorage.get(this._checkItemDraftKey('name'));
};
export const _discardCheckItemDraft = function () {
  TrelloStorage.unset(this._checkItemDraftKey('name'));
};

export const saveCheckItemDrafts = function (
  invokeSource: 'removing view' | 'unload',
) {
  if (!this.model.id) {
    return false;
  }

  for (const $el of this.getCheckItemEdits()) {
    const attr = $el.attr('attr');
    const val = $el.find('.js-checkitem-input:first').val();
    if ($.trim(val).length === 0) {
      continue;
    } // Not in edit mode

    if (
      this.model.get('name') !== val &&
      val !== this._recallCheckItemDraft()
    ) {
      if (invokeSource) {
        Analytics.sendTrackEvent({
          action: 'saved',
          actionSubject: 'checkItemDraft',
          source: 'cardDetailScreen',
          attributes: {
            invokeSource: invokeSource,
          },
        });
      }
      this._saveCheckItemDraft(attr, val);
    }
  }
};

export const recallCheckItemDrafts = function () {
  this.getCheckItemEdits().each((i: number, $el: JQuery) => {
    if (this.model.id) {
      const draftVal = this._recallCheckItemDraft();
      if (draftVal) {
        const $input = $el.find('.field:first');
        $input.val(draftVal);
        this.defer(() => {
          $el.find('.edits-warning').show();
        });
      }
    }
  });
};

export const getCheckItemEdits = function () {
  const $allEdits = this.$('[attr]');
  // Make sure we don't process other editables that are nested
  // inside this one
  const $noEdits = this.$('.js-no-higher-edits [attr]');

  return $allEdits
    .not($noEdits)
    .map((index: number, el: HTMLDivElement) => $(el));
};

export const onCheckItemClick = function (e: MouseEvent) {
  const $link = $(e.target).closest('a');
  if ($link.length > 0 && $link.attr('href') !== '#') {
    return;
  }
  if (DragSort.sorting) {
    return;
  }
  const $noEditableView = $(e.target).closest('.ignore-editable-view');
  if ($noEditableView.length > 0) {
    return;
  }

  const $container = $(e.target).closest('.editable');
  if ($container.length === 0) {
    return;
  }

  if ($(e.target).closest('.js-react-root').length) {
    return;
  }

  // If they've selected some text, they're probably trying to copy it
  if (hasSelectionIn($container)) {
    return;
  }

  stopPropagationAndPreventDefault(e);
  PopOver.hide();

  const attr = $container.attr('attr');

  this.editCheckItem(attr);
};

export const checkItemKeydownEvent = function (e: JQuery.KeyDownEvent) {
  applyMarkdownShortcuts(e, true);

  if ($('.editing').length > 0) {
    if (
      PopOver.view instanceof EmojiCompleterView ||
      PopOver.view instanceof AutoMentionerView
    ) {
      this.checkInsert(e);
    } else if (isSubmitEvent(e)) {
      this.commitCheckItemEdits(e);
    }
  }
};

export const checkItemEditControlKeydown = function (e: JQuery.KeyDownEvent) {
  if (getKey(e) === Key.Escape) {
    stopPropagationAndPreventDefault(e);

    if (PopOver.isVisible) {
      PopOver.hide();
    } else {
      this.clearEdits(e);
    }
  }
};

export const clearEdits = function (e: JQuery.KeyUpEvent) {
  stopPropagationAndPreventDefault(e);
  const $editable = $(e.target).closest('.editable[attr]');

  this._discardCheckItemDraft('name');

  $editable.find('.js-checkitem-input').val('');
  $editable.find('.edits-warning').hide();
  $editable.find('.edits-error').hide();
  $editable.removeClass('editing');
  Layout.cancelEdits();
  return false;
};

export const renderEditItemButtons = function () {
  const $editControls = this.$('.edit-controls');
  if ($editControls.length) {
    const idMember = this.model.get('idMember');
    const due = this.model.get('due');

    const member = idMember && this.modelCache.get('Member', idMember);
    const fullName = member ? member.get('fullName') : undefined;
    $editControls.find('.js-assign').html(editAssignTemplate(fullName));

    const dueText = due && Dates.toDateString(due);
    $editControls.find('.js-due').html(editDueTemplate(dueText));
  }

  return this;
};

export const commitCheckItemEdits = function (e: MouseEvent) {
  PopOver.hide();

  if (e) {
    stopPropagationAndPreventDefault(e);
  }

  const cardId = this.model.getCard().id;
  const boardId = this.model.getBoard().id;

  if (this.$('.js-checkitem-input').val().length === 0) {
    const destroyTraceId = Analytics.startTask({
      taskName: 'delete-checkItem',
      source: 'cardDetailScreen',
    });

    this.model.destroyWithTracing(
      { traceId: destroyTraceId },
      tracingCallback(
        {
          taskName: 'delete-checkItem',
          source: 'cardDetailScreen',
          traceId: destroyTraceId,
        },
        function (err) {
          if (!err) {
            Analytics.sendTrackEvent({
              action: 'deleted',
              actionSubject: 'checkItem',
              source: 'cardDetailScreen',
              attributes: {
                taskId: destroyTraceId,
              },
              containers: {
                card: { id: cardId },
                board: { id: boardId },
              },
            });
          }
        },
      ),
    );
  }

  const $editable = $(e.target).closest('.editable.editing[attr]');
  $editable.find('.edits-error').hide();

  if (!this.validateCheckItemInput()) {
    return;
  }

  const { model } = this;

  // Remove buttons
  $editable.remove('input[type=submit]');

  // Remove buttons and commit all other edits
  $editable
    .removeClass('editing')
    .each((index: number, el: HTMLElement) => {
      const $el = $(el);
      const attr = $el.attr('attr');
      let newValue = $el.find('.js-checkitem-input').val();

      if (!this.allowNewlines) {
        newValue = newValue.replace(/[\r\n]+/g, ' ');
      }

      // if the newValue is all whitespace, replace it with the empty string
      if ($.trim(newValue).length === 0) {
        newValue = '';
      }

      if (model.get('name') === newValue) {
        this._discardCheckItemDraft('name');
      } else {
        const traceId = Analytics.startTask({
          taskName: 'edit-checkItem/name',
          source: 'cardDetailScreen',
        });

        model.update(
          { name: newValue, traceId },
          tracingCallback(
            {
              taskName: 'edit-checkItem/name',
              source: 'cardDetailScreen',
              traceId,
            },
            (err) => {
              if (err) {
                $editable.find('.edits-error').text(err.message).show();
                this._saveCheckItemDraft(attr, newValue);
              } else {
                this._discardCheckItemDraft(attr);
                Analytics.sendTrackEvent({
                  action: 'updated',
                  actionSubject: 'checkItem',
                  actionSubjectId: 'name',
                  source: 'cardDetailScreen',
                  attributes: {
                    taskId: traceId,
                  },
                  containers: {
                    card: { id: cardId },
                    board: { id: boardId },
                  },
                });
              }
            },
          ),
        );
        markdownTracker(newValue, 'checkItems');
      }
    })
    .find('.js-checkitem-input')
    .val('');

  $editable.find('.edits-warning').hide();

  return true;
};

export const validateCheckItemInput = function () {
  const checkItemInputValue = this.$('.js-checkitem-input').val();

  if (/^\s*$/.test(checkItemInputValue)) {
    return false;
  }

  const fieldLength = checkItemInputValue.length;
  if (fieldLength > 16384) {
    this.$('.editing')
      .find('.edits-error')
      .text(l('text too long', { over: asNumber(fieldLength - 16384) }))
      .show();
    return false;
  }

  return true;
};

export const editCheckItem = function (sAttr: string) {
  let parts;
  if (sAttr.indexOf('.') > -1) {
    parts = sAttr.split('.');
    sAttr = parts[1];
  }

  const allEditableWithAttr = this.$(`[attr=${sAttr}]`);
  const noEdits = this.$(`.js-no-higher-edits [attr=${sAttr}]`);
  const container = allEditableWithAttr.not(noEdits);
  if (container.length === 0) {
    return;
  }

  Layout.cancelEdits();
  const edit = container.find('.edit:first');
  if (edit.length === 0) {
    return;
  }

  const input = container.find('.js-checkitem-input:first');

  const board = this.model.getBoard();
  const showButtons = Boolean(
    board
      ? board.hasAdvancedChecklists() || board.upsellAdvancedChecklists()
      : undefined,
  );

  edit.append(editTemplate());

  const editableViewButton = this.el.querySelector('.js-overflow-button-react');

  this.renderOverflowButton(editableViewButton, { editableView: true });

  this.$('.js-assign,.js-due').toggleClass('hide', !showButtons);
  this.renderEditItemButtons();

  container.addClass('editing');

  if (input.val() === '') {
    input.val(Util.traverse(this.model.attributes, parts || sAttr));
  }

  this.waitForId(this.model, () => {
    input.data('draftKey', this._checkItemDraftKey());
  });

  input.focus().select();
  input.autosize({ append: false });
};
